import {RESOLVE_DESIGN_MODE_FROM_URL} from '.';
import 'url-search-params-polyfill';

const resolveDesignModeFromUrl = ({dispatch}) => {
  let queryParams = new URLSearchParams(document.location.search.substring(1));
  let designMode = queryParams.get("designMode");

  dispatch({
    type: RESOLVE_DESIGN_MODE_FROM_URL,
    designMode: designMode === 'active'
  });
};

export default resolveDesignModeFromUrl;
